import * as React from "react";
const SvgFiRrAmbulance = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ambulance_svg__a)">
      <path
        fill="#062147"
        d="m23.052 11.654-1.819-4.09A6 6 0 0 0 15.75 4H14.4l-.66-2.642a1.793 1.793 0 0 0-3.48 0L9.6 4H5a5.006 5.006 0 0 0-5 5v8a2.99 2.99 0 0 0 2.071 2.838A3.4 3.4 0 0 0 2 20.5a3.5 3.5 0 1 0 7 0 3.5 3.5 0 0 0-.041-.5h6.082q-.04.25-.041.5a3.5 3.5 0 1 0 7 0 3.4 3.4 0 0 0-.071-.662A2.99 2.99 0 0 0 24 17v-.878a10.9 10.9 0 0 0-.948-4.468m-3.646-3.278L20.573 11H17a1 1 0 0 1-1-1V6.018a4 4 0 0 1 3.406 2.358M7 20.5a1.5 1.5 0 1 1-3 0c0-.17.032-.34.093-.5h2.814c.06.16.092.33.093.5M18.5 22a1.5 1.5 0 0 1-1.5-1.5c0-.17.032-.34.093-.5h2.814c.06.16.092.33.093.5a1.5 1.5 0 0 1-1.5 1.5m3.5-5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9a3 3 0 0 1 3-3h9v4a3 3 0 0 0 3 3h4.429c.376.998.569 2.056.571 3.122zm-11-5a1 1 0 0 1-1 1H9v1a1 1 0 1 1-2 0v-1H6a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 2 0v1h1a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ambulance_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAmbulance;
